import { useAppSelector } from '@store/hooks';
import { selectSafetyAllowed } from '@store/selectors/monitor.selectors';
import { useCanAccess } from '@permissions/useFeatures';

/**
 * Whether the Monitor page may show safety at all (the tab, the events list,
 * the alerts card and the floor drawer's Safety tab). Two independent
 * gates, both of which must pass: the role's `safety.view` feature, and the
 * upstream per-user `projectMonitor.safety` permission the snapshot carries.
 */
export function useSafetyVisible(): boolean {
  const projectAllows = useAppSelector(selectSafetyAllowed);
  const roleAllows = useCanAccess('safety.view');
  return projectAllows && roleAllows;
}
